var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    viewBox: "0 0 16 16",
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.162 14c-.296 0-.676-.096-1.15-.377l-1.67-.994c-.173-.102-.508-.102-.675 0l-1.675.994c-.988.59-1.569.354-1.831.163-.257-.19-.66-.68-.397-1.804l.397-1.725c.044-.18-.045-.49-.179-.624L2.597 8.239c-.692-.697-.636-1.293-.541-1.585s.396-.81 1.357-.973l1.78-.297a.8.8 0 0 0 .48-.36l.989-1.984C7.109 2.135 7.695 2 8.002 2s.893.135 1.34 1.04l.982 1.978c.079.152.319.332.486.36l1.781.298c.966.163 1.267.68 1.357.972.089.293.145.888-.542 1.585l-1.384 1.4c-.134.135-.218.438-.18.624l.397 1.725c.257 1.124-.14 1.613-.396 1.804-.14.102-.363.214-.681.214"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarActive);
export default __webpack_public_path__ + "static/media/starActive.ac5f545dd52e832e12bae741535f1449.svg";
export { ForwardRef as ReactComponent };